import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilsService {
  public imageUrlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      fetch(url).then(r => r.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = () => {
            resolve(reader.result as string);
        };
        reader.readAsDataURL(blob);
      })
      .catch((err) => {
        reject(err);
      });
    });
  }
}
